// extracted by mini-css-extract-plugin
module.exports = {"container":"Item_container__2jeJx","left":"Item_left__dqrAN","right":"Item_right__1iNra","title":"Item_title__13sDs","pdf":"Item_pdf__3qB_J","specs":"Item_specs__1EzM0"};